import { useSelector } from '../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

export const mapSettingsFilteringSelector = (state: AppState) => state.map.mapSettings.data.filtering.settings;
export const useMapSettingsFilteringSelector = () => useSelector(mapSettingsFilteringSelector);

export const useAreMapSettingsFilteringSettingsActive = () => {
  const settingsState = useMapSettingsFilteringSelector();

  return Object.values(settingsState).some(perColumnSettings =>
    !!Object.values(perColumnSettings).length
  );
};
